import { callTool } from "../api";
import { ratingLineage } from "../ratings";
import { WalkIcon } from "./BoothNavButton";

export async function loadMyWalk(accountId: string, actor: string): Promise<boolean> {
  const data = await callTool<{ results?: Array<{ owner?: boolean; is_owner?: boolean }> }>("account_tag_list", {
    account_id: accountId,
    user: actor,
    limit: 5,
  });
  const mine = data.results?.[0];
  return Boolean(mine?.owner ?? mine?.is_owner);
}

export async function putMyWalk(accountId: string, actor: string, owner: boolean): Promise<void> {
  await callTool("account_tag_put", {
    account_id: accountId,
    user: actor,
    actor,
    lineage: ratingLineage(),
    owner,
  });
}

export function WalkPlanButton({
  on,
  busy,
  onToggle,
  size = 14,
  showLabel = true,
}: {
  on: boolean;
  busy?: boolean;
  onToggle: () => void;
  size?: number;
  showLabel?: boolean;
}) {
  return (
    <button
      type="button"
      className={`ghost walk-chip ${on ? "on" : ""}${showLabel ? "" : " is-icon"}`}
      aria-pressed={on}
      aria-label={on ? "Remove from walk plan" : "Add to walk plan"}
      title={on ? "On your walk plan" : "Add to walk plan"}
      disabled={busy}
      onClick={onToggle}
    >
      <WalkIcon size={size} />
      {showLabel ? "Walk" : null}
    </button>
  );
}

export function ContinueWalkPrompt({
  busy,
  error,
  onChoose,
}: {
  busy?: boolean;
  error?: string | null;
  onChoose: (walk: boolean) => void;
}) {
  return (
    <div className="continue-walk" role="group" aria-label="Continue to Walk">
      <p className="continue-walk-label">Continue to Walk</p>
      <div className="continue-walk-actions">
        <button type="button" disabled={busy} onClick={() => onChoose(true)}>
          Y
        </button>
        <button type="button" className="secondary" disabled={busy} onClick={() => onChoose(false)}>
          N
        </button>
      </div>
      {error ? <p className="err">{error}</p> : null}
    </div>
  );
}
